const getHisHerPronoun = gender => {
    if (!gender) {
        return 'his/her';
    }
    return gender === 'M' ? 'his' : 'her';
}

export { getHisHerPronoun };